import { inject, NgModule } from "@angular/core";
import { Routes, RouterModule, Router } from "@angular/router";
import { AutoLoginGuardService } from "#guards/auto-login-guard-service";

import { BackgroundComponent } from "#core/components/background/background.component";

import { LoginFormComponent } from "#login/components/login-form/login-form.component";
import { LoginRegistrationComponent } from "#login/components/login-register/login-registration.component";
import { LoginOnboardNewUserComponent } from "#login/components/login-onboard-new-user/login-onboard-new-user.component";
import { LoginOnboardExistingUserComponent } from "#login/components/login-onboard-existing-user/login-onboard-existing-user.component";
import { LoginForgotPwdComponent } from "#login/components/login-forgot-pwd/login-forgot-pwd.component";
import { LoginTempPwdComponent } from "#login/components/login-temp-pwd/login-temp-pwd.component";
import { LoginCleverComponent } from "#login/components/login-clever/login-clever.component";
import { LoginClassLinkComponent } from "#login/components/login-classlink/login-classlink.component";
import { OauthAuthorizeComponent } from "#login/components/oauth/authorize/oauth-authorize.component";
import { LoginResetPwdComponent } from "#login/components/login-reset-pwd/login-reset-pwd.component";
import { LoginOnboardDistrictTeachersComponent } from "#login/components/login-onboard-district-teachers/login-onboard-district-teachers.component";
import { LoginSampleCenterComponent } from "#login/components/login-sample-center/login-sample-center.component";

import { OAuthGuardService } from "#guards/oauth-guard.service";

const routes: Routes = [
    {
        path: "login",
        component: BackgroundComponent,
        canActivate: [AutoLoginGuardService],
        children: [
            { path: "form", component: LoginFormComponent },
            { path: "register", component: LoginRegistrationComponent },
            {
                path: "onboard-new-user",
                component: LoginOnboardNewUserComponent
            },
            {
                path: "onboard-existing-user",
                component: LoginOnboardExistingUserComponent
            },
            { path: "forgot-pwd", component: LoginForgotPwdComponent },
            { path: "**", redirectTo: "form", pathMatch: "prefix" }
        ]
    },
    {
        path: "onboard-district",
        component: BackgroundComponent,
        children: [
            { path: "form", component: LoginOnboardDistrictTeachersComponent },
            { path: "**", redirectTo: "form", pathMatch: "prefix"}
        ]
    },
    {
        path: "reset-password",
        component: BackgroundComponent,
        children: [
            { path: "form", component: LoginResetPwdComponent },
            { path: "**", redirectTo: "form", pathMatch: "prefix" }
        ]
    },
    {
        path: "temp-password",
        component: BackgroundComponent,
        children: [
            { path: "form", component: LoginTempPwdComponent },
            { path: "**", redirectTo: "form", pathMatch: "prefix" }
        ]
    },
    {
        path: "clever",
        component: BackgroundComponent,
        children: [
            { path: "authorize", component: LoginCleverComponent },
            { path: "**", redirectTo: "authorize", pathMatch: "prefix" }
        ]
    },
    {
        path: "classlink",
        component: BackgroundComponent,
        children: [
            { path: "authorize", component: LoginClassLinkComponent },
            { path: "**", redirectTo: "authorize", pathMatch: "prefix" }
        ]
    },
    {
        path: "oauth",
        component: BackgroundComponent,
        children: [
            {
                path: "authorize",
                component: OauthAuthorizeComponent,
                canActivate: [OAuthGuardService]
            },
            { path: "login", component: LoginFormComponent }
        ]
    },
    {
        path: "cl-sample-center",
        component: BackgroundComponent,
        children: [
            { path: "authorize", component: LoginSampleCenterComponent },
            { path: "**", redirectTo: "authorize", pathMatch: "prefix" }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LoginRoutingModule {}
